import { CIcon } from '~/icons/types'

export const ciQuestionCircle: CIcon = {
  width: '24',
  height: '24',
  paths: [
    { d: 'M12 16.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z' },
    {
      d:
        'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16.001A8 8 0 0 1 12 20Z'
    },
    {
      d:
        'M14.79 6.78a4.25 4.25 0 0 0-2.42-1 4.65 4.65 0 0 0-3.09.77 3.71 3.71 0 0 0-1.59 2.04A3.37 3.37 0 0 0 7.64 10a1.015 1.015 0 1 0 2-.36 1.3 1.3 0 0 1 0-.59c.14-.403.42-.74.79-.95a2.6 2.6 0 0 1 1.72-.42 2.41 2.41 0 0 1 1.38.6c.276.263.447.619.48 1a1.47 1.47 0 0 1-.54 1.11c-.132.117-.28.214-.44.29a3.74 3.74 0 0 0-2 2.54 3 3 0 0 0 0 1.12 1 1 0 0 0 1 .82h.18a1 1 0 0 0 .8-1.16 1.21 1.21 0 0 1 0-.38 1.77 1.77 0 0 1 .91-1.12c.323-.155.622-.353.89-.59A3.432 3.432 0 0 0 16 9.37a3.58 3.58 0 0 0-1.09-2.48l-.12-.11Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'question-circle',
  type: 'regular'
}
